module.exports = __webpack_public_path__ + "static/media/start screen.63baec34.svg";